import React, { useState, useEffect, useMemo, useRef, useContext } from 'react';

import { Box, Fab, Stack, TextField } from '@mui/material';

import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

import Axios from '../../Assets/Axios/Axios';

import { TypoPoppins } from '../../Components/Typo';

import { COLORS } from '../../Constant/COLORS';

import ToastContext from '../../Context/ToastContext';
import { useAuthContext } from '../../Context/AuthContext';

import { FindReviewsByProfessional } from '../../Server/Query';

import Layout from './Components/Layout';
import ReviewCard from './Components/ReviewCard';

import { dummyReviews } from '../../lib/DummyData/professionalPage';

const ReviewManage = () => {
  const { showToastMessage } = useContext(ToastContext);
  // const { user } = useAuthContext();

  const [reviews, setReviews] = useState(dummyReviews);
  const [filteredByDate, setFilteredByDate] = useState('');
  const [isScrollTopVisible, setIsScrollTopVisible] = useState(false);

  const scrollableContainer = useRef();

  const filteredReviews = useMemo(
    () =>
      filteredByDate
        ? reviews.filter(
            review =>
              new Date(review.date).setHours(0, 0, 0, 0).valueOf() ===
              new Date(filteredByDate).setHours(0, 0, 0, 0).valueOf()
          )
        : reviews,
    [filteredByDate, reviews]
  );

  // useEffect(() => {
  //   const query = FindReviewsByProfessional({ professionalId: user.userID });
  //   Axios({ query }).then(({ data, errors }) => {
  //     if (errors) {
  //       showToastMessage('Something went wrong');
  //       return undefined;
  //     }
  //     setReviews(data.Reviews.map(parserReview));
  //   });
  // }, [showToastMessage, user.userID]);

  function handleChange({ target: { value } }) {
    setFilteredByDate(value);
  }

  function handleScrollTopVisibility(event) {
    const shouldScrollTopVisible = event.currentTarget.scrollTop > 100;
    if (shouldScrollTopVisible !== isScrollTopVisible)
      setIsScrollTopVisible(shouldScrollTopVisible);
  }

  function handleScrollTop() {
    scrollableContainer.current.scrollTo({ top: 0, behavior: 'smooth' });
  }

  return (
    <Layout message='Review Manage' isAvatarButtonsAvailable={false}>
      <Box
        gap={2}
        display='grid'
        width='fit-content'
        mx={{ xs: 'auto', md: 'unset' }}
        gridTemplateAreas={{
          xs: ['"empty search" "card card"'],
          md: ['"empty empty search" "card card card"'],
        }}
      >
        <TextField
          fullWidth
          type='date'
          value={filteredByDate}
          onChange={handleChange}
          sx={{ bgcolor: COLORS.white3, gridArea: 'search' }}
        />

        <Box gridArea='card' position='relative'>
          <Stack
            px={2}
            pb={2}
            gap={3}
            maxHeight={500}
            overflow='auto'
            ref={scrollableContainer}
            onScroll={handleScrollTopVisibility}
          >
            {filteredReviews.length === 0 && (
              <TypoPoppins
                minWidth={{ md: '500px' }}
                variant='h6'
                fontWeight={400}
                color='text.secondary'
                variantMapping={{ h6: 'p' }}
              >
                No reviews found
              </TypoPoppins>
            )}
            {filteredReviews.map(review => (
              <Box maxWidth={550} key={review.id}>
                <ReviewCard {...review} />
              </Box>
            ))}
          </Stack>
          {isScrollTopVisible && (
            <Fab
              size='small'
              onClick={handleScrollTop}
              sx={{ position: 'absolute', right: '16px', bottom: '8px' }}
            >
              <ArrowUpwardIcon />
            </Fab>
          )}
        </Box>
      </Box>
    </Layout>
  );
};

function parserReview(review) {
  const order = review.Order;
  const eventBooker = order.EventBooker;
  const name = eventBooker.first_name.concat(' ', eventBooker.last_name);

  return {
    id: review.id,
    name,
    referenceId: order.reference_id,
    jobID: order.id,
    date: order.date.split('T')[0],
    review: review.description,
    isActive: review.is_active,
  };
}

export default ReviewManage;
